module.exports = __webpack_public_path__ + "img/yangtzi_river.69272605.png";